import React, {useContext, useEffect} from "react";
import {useFormContext} from "react-hook-form";
import {Link} from 'react-router-dom'

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Button from '@mui/material/Button';
import { DataGrid } from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import dayjs from 'dayjs';
import 'dayjs/locale/ro';

import {Loading} from '../../custom/LoadingComponent';
import {getEmployerSelectData, getWorksiteSelectData, getAuthzInternalName, getRsvtiOperatorSelectData} from '../../util/TypeConvertor';
import * as CustomStyles from '../../styles/CustomStyles';
import * as ValidationMessages from '../../constants/ValidationMessages';
import * as DataPattern from '../../constants/DataPattern';
import * as RestCall from '../../../utils/network/RestCalls';
import * as DateHelper from '../../util/DateHelper';
import * as Formatter from '../../util/Formatter';
import * as CustomSelectData from '../../constants/CustomSelectData';
import * as Consts from '../../constants/Consts';
import { DocAuthzInternal, TaskExamStatus } from "../../constants/Consts";
import BucketContext from "../../context/BucketContext";


const fetchAndEnrichReminders = async (clientId, startDate, endDate) => {
    const ddbReminders = await RestCall.fetchReminders(clientId, startDate, endDate)
        .then((reminders) => reminders.map( (rem) => {return {...rem, id: rem.extra.employeeId + '#' + rem.id} }) )
        .catch(error => console.log(error));    

    const filteredReminders = ddbReminders.filter(reminder => reminder.details.type === Consts.REMINDER_RENEW_CERTIFICATE);
    return filteredReminders;
}


export function CertRenewalStep0(props) {
    console.log('___Step 0___');
    const { register, setValue, formState: { errors, defaultValues } } = useFormContext();

    const [scheduledDate, setScheduledDate] = React.useState(!!defaultValues.lTask?.step0?.scheduledDate ? dayjs(`${defaultValues.lTask.step0.scheduledDate}`) : null);

    useEffect(() => {
        setValue('lTask.step0.scheduledDate', scheduledDate);
    }, []);

    const validateDataProgramare = (scheduledDateStr) => {
        if(scheduledDateStr) {
            if( DateHelper.isValidStringDateFmt(scheduledDateStr) ) {
                const sDate = DateHelper.getDateFromString(scheduledDateStr).hour(0).minute(0).second(0).millisecond(0);
                const today = dayjs().hour(0).minute(0).second(0).millisecond(0);
                if(sDate < today) {
                    return 'Data nu poate sa fie in trecut';
                }
                else {
                    return true;
                }
            }
            else {
                return 'Format data este invalid';
            }
        }
        else {
            return true;
        }
    }

    return(
        <Box sx={CustomStyles.boxStyles}  >
            <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Detalii Programare</Typography>

            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ro'>
                        <DesktopDatePicker
                            label="Data Programare"
                            inputFormat={DataPattern.DATE_FORMAT_RO}
                            value={scheduledDate}
                            onChange={(newValue) => {
                                setScheduledDate(newValue);
                                if(newValue && newValue.isValid()) {
                                    setValue('lTask.step0.scheduledDate', newValue.toISOString());
                                }
                            }}
                            renderInput={(params) => 
                                <TextField {...params} variant="standard" 
                                    {...register('lTask.step0.scheduledDate', 
                                        {required: ValidationMessages.REQUITED_MESSAGE, 
                                         validate: vd => validateDataProgramare(vd)}
                                    )}
                                    error={!!errors?.lTask?.step0?.scheduledDate}
                                    helperText={errors?.lTask?.step0?.scheduledDate ? errors.lTask.step0.scheduledDate.message : null}
                                />
                            }
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={4}>
                </Grid>
                <Grid item xs={4}>
                </Grid>
            </Grid>
        </Box>
    );

}


const columns = [
    {
        field: 'fullName',
        headerName: 'Nume',
        width: 200,
        valueGetter: (params) => params.row.extra.eFullName,
        renderCell: (params) => {
            const eeId = params.row.id.split('#')[0];
            const erId = params.row.extra.employerId;
            return(
                <Link to={`/employees/${eeId}?employerId=${erId}`}>
                    {params.row.extra.eFullName}
                </Link>
            );
        }

    },
    {
        field: 'authzType',
        headerName: 'Autorizatie Interna',
        width: 250,
        valueGetter: (params) => getAuthzInternalName(params.row.details.authInternal)
    },
    {
        field: 'expiryDate',
        headerName: 'Data Expirare',
        width: 150,
        valueGetter: (params) => dayjs(params.row.details.dataExpirare.slice(0,10)).format(DataPattern.DATE_FORMAT_RO)
    },
    {
        field: 'reminderDate',
        headerName: 'Data Reminder',
        width: 150,
        valueGetter: (params) => dayjs(params.row.details.dataReminder.slice(0,10)).format(DataPattern.DATE_FORMAT_RO)
    }
];


export function CertRenewalStep1(props) {
    console.log('___Step 1___');
    const { register, setValue, getValues, handleSubmit, formState: { errors, defaultValues } } = useFormContext();

    const [selectedEmployerId, setSelectedEmployerId] = React.useState( !!defaultValues.lTask.step1?.employerId ? defaultValues.lTask.step1.employerId : '' );
    const [selectedWorksiteId, setSelectedWorksiteId] = React.useState('');
    const [worksites, setWorksites] = React.useState([]);
    const [rsvtiOperators, setRsvtiOperators] = React.useState([]);
    const [selectedRsvtiOperatorUname, setSelectedRsvtiOperatorUname]= React.useState('');

    const employerSelectData = getEmployerSelectData(props.employers);
    const worksiteSelectData = getWorksiteSelectData(selectedEmployerId, worksites, false);
    const rsvtiOperatorSelectData = getRsvtiOperatorSelectData(rsvtiOperators);

    const [certificateDate, setCertificateDate] = React.useState(defaultValues.lTask.details.activeStep === 1 ? dayjs(`${defaultValues.lTask.step0.scheduledDate}`) : dayjs(`${defaultValues.lTask.step1?.newCertificateDate}`));

    const [dateFromValue, setDateFromValue] = React.useState( dayjs(`${defaultValues.lTask.step1?.dateFrom}`) );
    const [dateToValue, setDateToValue] = React.useState( dayjs(`${defaultValues.lTask.step1?.dateTo}`) );

    const [reminders, setReminders] = React.useState([]);
    const [selectedReminders, setSelectedReminders] = React.useState([]);
    const [isFetchingRems, setIsFetchingRems] = React.useState(false);


    const [disabledSelect, setDisabledSelect] = React.useState(defaultValues.lTask.details.activeStep > 1);

    useEffect(() => {
        if(defaultValues.lTask.details.activeStep === 1) {
            setValue('lTask.step1.scheduledReminders', []);
            setValue('lTask.step1.newCertificateDate', defaultValues.lTask.step0.scheduledDate);
        }
        else if(defaultValues.lTask.details.activeStep > 1) {
            setValue('lTask.step1.newCertificateDate', defaultValues.lTask.step1?.newCertificateDate);
            loadAndSetSelectedWorksite();
            loadAndSetSelectedRsvtiOp();
            fetchRemindersForWorksite(defaultValues.lTask.step1.workSiteId);
        }
    }, []);

    const loadAndSetSelectedWorksite = async () => {
        await loadWorksitesForEmployer(defaultValues.lTask.step1.employerId);
        setSelectedWorksiteId(defaultValues.lTask.step1.workSiteId);
    }

    const loadWorksitesForEmployer = async (employerId) => {
        const ddbWs = await RestCall.fetchEmployerWorksites(employerId)
                .catch(error => console.log(error)); 

        setWorksites(ddbWs);
    }

    const loadAndSetSelectedRsvtiOp = async () => {
        await loadRsvtiOperatorsForWorksite(defaultValues.lTask.step1.workSiteId);
        setSelectedRsvtiOperatorUname(defaultValues.lTask.step1.operatorRsvtiUname);
    }

    const loadRsvtiOperatorsForWorksite = async (worksiteId) => {
        const employer = props.employers.find((employer) => employer.id === selectedEmployerId);
        const clientId = employer.generalSection.rsvtiMBClientId;
        const ddbOps = await RestCall.fetchRsvtiOperators(clientId, worksiteId)
                .catch(error => console.log(error)); 

        setRsvtiOperators(ddbOps);
    }

    const handleFetchReminders = () => {
        fetchRemindersForWorksite(selectedWorksiteId);
    }

    const fetchRemindersForWorksite = async (wsId) => {
        console.log('Handle Fetch Current Reminders' );

        const startDate = dateFromValue.toISOString().slice(0,10);
        const endDate = dateToValue.toISOString().slice(0,10);
        const clientId = defaultValues.lTask.details.clientId;

        console.log("Client Id: " + clientId);
        console.log("Worksite Id: " + wsId);

        setIsFetchingRems(true);
        const ddbReminders = await fetchAndEnrichReminders(clientId, startDate, endDate);
        setIsFetchingRems(false);

        const wsReminders = ddbReminders.filter((reminder) => reminder.extra.worksiteId === wsId)
                                        .filter((reminder) => (!reminder.scheduling?.isScheduled || !defaultValues.lTask.step1?.scheduledReminders || defaultValues.lTask.step1.scheduledReminders.includes(reminder.id)));
        setReminders(wsReminders);

        setSelectedReminders(!!defaultValues.lTask.step1?.scheduledReminders ? defaultValues.lTask.step1.scheduledReminders : []);
    }

    const setSelectedAuthzsType = (ids) => {
        const authzsType = [];

        ids.forEach((id) => {
            for(const rem of reminders) {
                if(rem.id === id) {
                    if( !authzsType.includes(rem.details.authInternal) ) {
                        authzsType.push(rem.details.authInternal);
                    }
                    break;
                }
            }
        })

        setValue('lTask.step1.scheduledAuthzsType', authzsType);
    }

    const validateToDate = (dateToStr) => {
        if( DateHelper.isValidStringDateFmt(dateToStr) ) {
            const nDateTo = DateHelper.getDateFromString(dateToStr);
            const nDateFrom = DateHelper.getDateFromString(getValues('lTask.step1.dateTo'));

            if(dateToValue < dateFromValue) {
                return 'Data To este inainte de Data From';
            }
            else{
                return true;
            }
        }
        else {
            return 'Format data este invalid';
        }
    }

    const validateDateFmt = (stampDateStr) => {
        if(stampDateStr) {
            if( DateHelper.isValidStringDateFmt(stampDateStr) ) {
                return true;
            }
            else {
                return 'Format data este invalid';
            }
        }
        else {
            return true;
        }
    }


    return(
        <Box sx={CustomStyles.boxStyles}  >
            <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Datele de Angajare</Typography>

                <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                    {/*row*/}
                    <Grid item xs={4}>
                        <FormControl fullWidth size="small" margin="dense" variant="standard">
                            <InputLabel id={'daAngajator-inputLabelId'} error={!!errors?.lTask?.step1?.employerId}>Angajator</InputLabel>
                            <Select
                                {...register('lTask.step1.employerId', {required: ValidationMessages.REQUITED_MESSAGE})}
                                disabled={disabledSelect}
                                labelId={'daAngajator-selectLabelId'}
                                id={'daAngajator'}
                                value={selectedEmployerId}
                                onChange={(event) => {
                                    setSelectedEmployerId(event.target.value);
                                    setSelectedWorksiteId('');
                                    loadWorksitesForEmployer(event.target.value);
                                }}
                                label={'daAngajator-label'}
                                error={!!errors?.lTask?.step1?.employerId}
                                >
                                {
                                    employerSelectData.map((data) => <MenuItem dense value={data.id} key={data.id}> {data.name} </MenuItem>)
                                }
                            </Select>
                            <Typography sx={{ color: 'error.main', fontSize: 12 }}>{errors?.lTask?.step1?.employerId ? errors.lTask.step1.employerId.message : null}</Typography>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                        <FormControl fullWidth size="small" margin="dense" variant="standard">
                            <InputLabel id={'daWorkSite-inputLabelId'} error={!!errors?.lTask?.step1?.workSiteId}>Punct de Lucru</InputLabel>
                            <Select
                                {...register('lTask.step1.workSiteId', {required: ValidationMessages.REQUITED_MESSAGE})}
                                disabled={disabledSelect}
                                labelId={'daWorkSite-selectLabelId'}
                                id={'daWorkSite'}
                                value={selectedWorksiteId}
                                onChange={(event) => {
                                    setSelectedWorksiteId(event.target.value);
                                    setValue('lTask.step1.worksiteName', worksiteSelectData.find((ws) => ws.id === event.target.value).name);
                                    loadRsvtiOperatorsForWorksite(event.target.value);
                                }}
                                label={'daWorkSite-label'}
                                error={!!errors?.lTask?.step1?.workSiteId}
                                >
                                {
                                    worksiteSelectData.map((data) => <MenuItem dense value={data.id} key={data.id}> {data.name} </MenuItem>)
                                }
                            </Select>
                            <Typography sx={{ color: 'error.main', fontSize: 12 }}>{errors?.lTask?.step1?.workSiteId ? errors.lTask.step1.workSiteId.message : null}</Typography>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                        <FormControl fullWidth size="small" margin="dense" variant="standard">
                            <InputLabel id={'rsvtiOperator-inputLabelId'} error={!!errors?.lEmployee?.employmentDetails?.employerId}>Operator RSVTI</InputLabel>
                            <Select
                                {...register('lTask.step1.operatorRsvtiUname', {required: ValidationMessages.REQUITED_MESSAGE})}
                                labelId={'rsvtiOp-selectLabelId'}
                                id={'rsvtiOperator'}
                                value={selectedRsvtiOperatorUname}
                                onChange={(event) => {
                                    setSelectedRsvtiOperatorUname(event.target.value);
                                    // setValue('lTask.step1.worksiteName', worksiteSelectData.find((ws) => ws.id === event.target.value).name);
                                }}
                                label={'rsvtiOperator-label'}
                                error={!!errors?.lTask?.step1?.operatorRsvtiUname}
                                >
                                {
                                    rsvtiOperatorSelectData.map((data) => <MenuItem dense value={data.id} key={data.id}> {data.name} </MenuItem>)
                                }
                            </Select>
                            <Typography sx={{ color: 'error.main', fontSize: 12 }}>{errors?.lTask?.step1?.operatorRsvtiUname ? errors.lTask.step1.operatorRsvtiUname.message : null}</Typography>
                        </FormControl>
                    </Grid>

                    {/*row*/}
                    <Grid item xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ro'>
                            <DesktopDatePicker
                                disabled={!!props.disabled ? props.disabled : false}
                                label="Data Adeverinta"
                                inputFormat={DataPattern.DATE_FORMAT_RO}
                                value={certificateDate}
                                onChange={(newValue) => {
                                    setCertificateDate(newValue);
                                    if(newValue && newValue.isValid()) {
                                        setValue('lTask.step1.newCertificateDate', newValue.toISOString());
                                    }
                                }}
                                renderInput={(params) => 
                                    <TextField {...params} variant="standard" 
                                        {...register('lTask.step1.newCertificateDate', 
                                            {required: ValidationMessages.REQUITED_MESSAGE, 
                                            validate: vd => validateDateFmt(vd)}
                                        )}
                                        error={!!errors?.lTask?.step1?.newCertificateDate}
                                        helperText={errors?.lTask?.step1?.newCertificateDate ? errors.lTask.step1.newCertificateDate.message : null}
                                    />
                                }
                            />
                        </LocalizationProvider>
                    </Grid>

                    {/*row*/}
                    <Grid item xs={4}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ro'>
                            <DesktopDatePicker
                                label="Data From"
                                inputFormat={DataPattern.DATE_FORMAT_RO}
                                value={dateFromValue}
                                onChange={(newValue) => {
                                    setDateFromValue(newValue);
                                    if(newValue && newValue.isValid()) {
                                        setValue('lTask.step1.dateFrom', newValue.toISOString());
                                    }
                                }}
                                renderInput={(params) => 
                                    <TextField {...params} variant="standard" 
                                        {...register('lTask.step1.dateFrom', 
                                            {required: ValidationMessages.REQUITED_MESSAGE,
                                            validate: vd => validateDateFmt(vd)}
                                        )}
                                        error={!!errors?.lTask?.step1?.dateFrom}
                                        helperText={errors?.lTask?.step1?.dateFrom ? errors.lTask.step1.dateFrom.message : null}
                                    />
                                }
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={4}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ro'>
                            <DesktopDatePicker
                                label="Data To"
                                inputFormat={DataPattern.DATE_FORMAT_RO}
                                value={dateToValue}
                                onChange={(newValue) => {
                                    setDateToValue(newValue);
                                    if(newValue && newValue.isValid()) {
                                        setValue('lTask.step1.dateTo', newValue.toISOString());
                                    }
                                }}
                                renderInput={(params) => 
                                    <TextField {...params} variant="standard" 
                                        {...register('lTask.step1.dateTo', 
                                            {required: ValidationMessages.REQUITED_MESSAGE, 
                                            validate: vd =>  validateToDate(vd)}
                                        )}
                                        error={!!errors?.lTask?.step1?.dateTo}
                                        helperText={errors?.lTask?.step1?.dateTo ? errors.lTask.step1.dateTo.message : null}
                                    />
                                }
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={4}>
                        <Button variant="outlined" type="submit" name="Fetch" sx={{ marginRight: 1 }} onClick={handleSubmit( handleFetchReminders )} disabled={isFetchingRems}> 
                            {isFetchingRems && <CircularProgress size={25} />}
                            {!isFetchingRems && 'Incarca'}
                        </Button>
                    </Grid>

                    {/*row*/}
                    {!props.errMsg ?
                            <React.Fragment></React.Fragment>
                                :
                                <Grid item xs={12}>
                                <Typography
                                component="div"
                                color="error"
                                sx={{ flexGrow: 1, mr: 1, mt: 1 }}
                            >
                                {props.errMsg}
                            </Typography>
                            </Grid>
                        }

                    {/*row*/}
                    <Grid item xs={12}>
                        <Box sx={{ height: 650, width: '100%', marginTop: 2, marginBottom: 2 }}>
                            <DataGrid
                                {...register('lTask.step1.scheduledReminders')}
                                rows={reminders}
                                columns={columns}
                                initialState={{
                                    sorting: { sortModel: [{ field: 'fullName', sort: 'asc' }] }
                                }}    
                                pageSize={10}
                                rowsPerPageOptions={[10]}
                                checkboxSelection={true}
                                disableSelectionOnClick
                                experimentalFeatures={{ newEditingApi: true }}
                                selectionModel={selectedReminders}
                                onSelectionModelChange={(ids) => {
                                                            setValue('lTask.step1.scheduledReminders', ids);
                                                            setSelectedAuthzsType(ids);
                                                            setSelectedReminders(ids);
                                                        }}
                            />
                        </Box>
                    </Grid>

                </Grid>
        </Box>
    );

}

export function CertRenewalStep2(props) {
    console.log('___Step 2___');

    const bucketContext = useContext(BucketContext);

    const { formState: { defaultValues } } = useFormContext();

    const [reminders, setReminders] = React.useState([]);
    const [isFetchingRems, setIsFetchingRems] = React.useState(false);
    const [backdropOpen, setBackdropOpen] = React.useState(false);

    useEffect(() => {
        console.log('Use Effect');
        fetchSelectedReminders();
    }, []);

    const handleBackdropClose = () => {
        setBackdropOpen(false);
    };
    
    const handleBackdropOpen = () => {
        setBackdropOpen(true);
    };
    
      const fetchSelectedReminders = async () => {
        const startDate = defaultValues.lTask.step1.dateFrom.slice(0,10);
        const endDate = defaultValues.lTask.step1.dateTo.slice(0,10);
        const clientId = defaultValues.lTask.details.clientId;

        setIsFetchingRems(true);
        const ddbReminders = await fetchAndEnrichReminders(clientId, startDate, endDate);
        setIsFetchingRems(false);

        const wsReminders = ddbReminders.filter((reminder) =>  defaultValues.lTask.step1.scheduledReminders.includes(reminder.id) );
        setReminders(wsReminders);
    }

    const downloadFile = async (authzType, docType, fileName) => {

        handleBackdropOpen();
        return await RestCall.fetchAuthzIntDocument(authzType, docType, defaultValues.lTask.details.clientId, defaultValues.lTask.id)
            .then((blob) => {
                // Create blob link to download
                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    `${fileName}`,
                );
            
                // Append to html link element page
                document.body.appendChild(link);
            
                // Start download
                link.click();
            
                // Clean up and remove the link
                link.parentNode.removeChild(link);
            })
            .catch(error => {
                bucketContext.setBucketValue({ snackbar: { open: true, severity: "error", message: "Eroare - Documentul nu a putut fi generat!" } });
                console.log(error);
            })
            .finally(() => handleBackdropClose());
    }

    const downloadTest = async (authzType, fileName) => {
        return await RestCall.fetchDocTest(defaultValues.lTask.step1.operatorRsvtiUname, authzType, defaultValues.lTask.step1.employerId, defaultValues.lTask.step1.workSiteId)
            .then((blob) => {
                // Create blob link to download
                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    `${fileName}`,
                );
            
                // Append to html link element page
                document.body.appendChild(link);
            
                // Start download
                link.click();
            
                // Clean up and remove the link
                link.parentNode.removeChild(link);
            })
            .catch(error => console.log(error));    

    }

    return(
        <Box sx={CustomStyles.boxStyles}  >
            <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={backdropOpen}
                    // onClick={handleBackdropClose}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={2}>
                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Data Programare</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>
                        {Formatter.formatDatetoRO(defaultValues.lTask.step0.scheduledDate)}
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Data Adeverinta</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>
                        {Formatter.formatDatetoRO(defaultValues.lTask.step1.newCertificateDate)}
                    </Typography>
                </Grid>

                {/*row*/}
                <Grid item xs={2}>
                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>{defaultValues.lTask.step1.employerName}</Typography>
                </Grid>
                <Grid item xs={10}>
                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>{defaultValues.lTask.step1.worksiteName}</Typography>
                </Grid>

                {/*row*/}
                <Grid item xs={12}>
                    {defaultValues.lTask.step1.scheduledAuthzsType.map( authzType => (
                        <React.Fragment key={authzType}>
                            <Link onClick={() => downloadFile(authzType, DocAuthzInternal.CertificateAll, 'Adeverinta_' + authzType + '.docx')}>Adeverinta {getAuthzInternalName(authzType)}<FileDownloadIcon /></Link>
                            &nbsp;&nbsp;&nbsp;
                            {/* <Link onClick={() => downloadFile(authzType, DocAuthzInternal.Certificate, 'Adeverinta_' + authzType + '.docx')}>Adeverinta {getAuthzInternalName(authzType)}<FileDownloadIcon /></Link>
                            &nbsp;&nbsp;&nbsp;
                            <Link onClick={() => downloadFile(authzType, DocAuthzInternal.CertificatePrT, 'Adeverinta_ip_' + authzType + '.docx')}>Adeverinta IP {getAuthzInternalName(authzType)}<FileDownloadIcon /></Link>
                            &nbsp;&nbsp;&nbsp;
                            <Link onClick={() => downloadFile(authzType, DocAuthzInternal.CertificateThT, 'Adeverinta_it_' + authzType + '.docx')}>Adeverinta IT {getAuthzInternalName(authzType)}<FileDownloadIcon /></Link>
                            &nbsp;&nbsp;&nbsp; */}
                            <Link onClick={() => downloadFile(authzType, DocAuthzInternal.PvResults, 'PVRezultate_' + authzType + '.docx')}>PV Rezultate {getAuthzInternalName(authzType)}<FileDownloadIcon /></Link>
                            {/* &nbsp;&nbsp;&nbsp;
                            <Link onClick={() => downloadTest(authzType, 'Test_' + authzType + '.docx')}>Test {getAuthzInternalName(authzType)}<FileDownloadIcon /></Link> */}
                        </React.Fragment>
                    ))}
                </Grid>

                {/*row*/}
                <Grid item xs={12}>
                    <Box sx={{ height: 650, width: '100%', marginTop: 2, marginBottom: 2 }}>
                        {isFetchingRems ? 
                            <Loading />
                                :
                            <DataGrid
                                rows={reminders}
                                columns={columns}
                                initialState={{
                                    sorting: { sortModel: [{ field: 'fullName', sort: 'asc' }] }
                                }}    
                                pageSize={10}
                                rowsPerPageOptions={[10]}
                                checkboxSelection={false}
                                disableSelectionOnClick
                                experimentalFeatures={{ newEditingApi: true }}
                            />
                        }
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );

}



export function CertRenewalStep3(props) {
    console.log('___Step 3___');
    const { register, setValue, formState: { defaultValues } } = useFormContext();

    const examColumns = [
        {
            field: 'fullName',
            headerName: 'Nume',
            width: 200,
            valueGetter: (params) => params.row.eFullName,
            renderCell: (params) => {
                const eeId = params.row.id.split('#')[0];
                const erId = params.row.employerId;
                return(
                    <Link to={`/employees/${eeId}?employerId=${erId}`}>
                        {params.row.eFullName}
                    </Link>
                );
            }
        },
        {
            field: 'authzType',
            headerName: 'Autorizatie Interna',
            width: 250,
            valueGetter: (params) => getAuthzInternalName(params.row.authInternal)
        },
        {
            field: 'expiryDate',
            headerName: 'Data Expirare',
            width: 150,
            valueGetter: (params) => dayjs(params.row.dataExpirare.slice(0,10)).format(DataPattern.DATE_FORMAT_RO)
        },
        {
            field: 'examResult',
            headerName: 'Rezultat Examinare (*)',
            type: 'singleSelect',
            width: 160,
            valueOptions: CustomSelectData.examResultStatus,
            valueFormatter: ({ id, value, field, api }) => {
                updateParticipantExamResult(id, value);
                const colDef = api.getColumn(field);
                const option = colDef.valueOptions.find(
                  ({ value: optionValue }) => value === optionValue
                );
          
                return option.label;
            },
            editable: true
          }
    ];

    const [examParticipants, setExamParticipants] = React.useState([]);

    useEffect(() => {
        console.log('Use Effect');

        fetetchSelectedReminders();
    }, []);


    const updateParticipantExamResult = (id, value) => {
        examParticipants.forEach((participant) => {
            if(participant.id === id && participant.examResult != value) {
                participant.examResult = value;
                setValue('lTask.step3.examParticipants', examParticipants);
            }  
        })
}


    const fetetchSelectedReminders = async () => {
        const startDate = defaultValues.lTask.step1.dateFrom.slice(0,10);
        const endDate = defaultValues.lTask.step1.dateTo.slice(0,10);
        const clientId = defaultValues.lTask.details.clientId;

        const ddbReminders = await fetchAndEnrichReminders(clientId, startDate, endDate);
        const wsReminders = ddbReminders.filter((reminder) =>  defaultValues.lTask.step1.scheduledReminders.includes(reminder.id) );
                                    //     .map( (reminder) => {  
                                    //         var temp = Object.assign({}, reminder);
                                    //         temp.county= Consts.EXAM_STATUS_ACCEPTED; 
                                    //         return temp; 
                                    // });

        const participants = wsReminders.map((reminder) => {
                                        const pasticipant = {
                                            id: reminder.id,
                                            employerId: reminder.extra.employerId,
                                            eFullName: reminder.extra.eFullName,
                                            authInternal: reminder.details.authInternal,
                                            dataExpirare: reminder.details.dataExpirare,
                                            examResult: TaskExamStatus.Accepted
                                        };
                                        return pasticipant;
                                    });
        setExamParticipants(participants);
        setValue('lTask.step3.examParticipants', participants);
    }

    return(
        <Box sx={CustomStyles.boxStyles}  >
            <Grid container spacing={2} sx={CustomStyles.gridStyles}>

                {/*row*/}
                <Grid item xs={2}>
                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Data Reinnoire Adeverinta</Typography>
                </Grid>
                <Grid item xs={10}>
                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>
                        {Formatter.formatDatetoRO(defaultValues.lTask.step1.newCertificateDate)}
                    </Typography>
                </Grid>

                {/*row*/}
                <Grid item xs={12}>
                    <TextField
                        variant="standard" 
                        id="outlined-multiline-static"
                        label="Comentariu"
                        multiline fullWidth margin="dense" 
                        rows={4}
                        {...register("lTask.step3.comments")}
                    />                        
                </Grid>

                {/*row*/}
                <Grid item xs={12}>
                    <Box sx={{ height: 650, width: '100%', marginTop: 2, marginBottom: 2 }}>
                        <DataGrid
                            rows={examParticipants}
                            columns={examColumns}
                            initialState={{
                                sorting: { sortModel: [{ field: 'fullName', sort: 'asc' }] }
                            }}    
                            pageSize={10}
                            rowsPerPageOptions={[10]}
                            checkboxSelection={false}
                            disableSelectionOnClick
                            experimentalFeatures={{ newEditingApi: true }}
                        />
                    </Box>
                </Grid>
            </Grid>                
        </Box>
    );

}




export function CertRenewalScheduleSummary(props) {
    console.log('___CertificateRenewalScheduleSummary___');
    const { formState: { defaultValues } } = useFormContext();

    const examColumns = [
        {
            field: 'fullName',
            headerName: 'Nume',
            width: 200,
            valueGetter: (params) => params.row.eFullName,
            renderCell: (params) => {
                const eeId = params.row.id.split('#')[0];
                const erId = params.row.employerId;
                return(
                    <Link to={`/employees/${eeId}?employerId=${erId}`}>
                        {params.row.eFullName}
                    </Link>
                );
            }
        },
        {
            field: 'authzType',
            headerName: 'Autorizatie Interna',
            width: 200,
            valueGetter: (params) => getAuthzInternalName(params.row.authInternal)
        },
        {
            field: 'expiryDate',
            headerName: 'Data Expirare',
            width: 150,
            valueGetter: (params) => dayjs(params.row.dataExpirare.slice(0,10)).format(DataPattern.DATE_FORMAT_RO)
        },
        {
            field: 'examResult',
            headerName: 'Rezultat Examinare',
            type: 'singleSelect',
            width: 160,
            valueOptions: CustomSelectData.examResultStatus,
            valueFormatter: ({ id, value, field, api }) => {
                const colDef = api.getColumn(field);
                const option = colDef.valueOptions.find(
                  ({ value: optionValue }) => value === optionValue
                );
          
                return option.label;
              },
            editable: false
          }
    ];

    return(
        <React.Fragment>
            <Typography sx={{ mt: 2, mb: 1 }}>
                Flux complet
            </Typography>

        <Box sx={CustomStyles.boxStyles}  >
            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={2}>
                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Data Programare</Typography>
                </Grid>
                <Grid item xs={10}>
                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>
                        {Formatter.formatDatetoRO(defaultValues.lTask.step0.scheduledDate)}
                    </Typography>
                </Grid>

                {/*row*/}
                <Grid item xs={2}>
                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>{defaultValues.lTask.step1.employerName}</Typography>
                </Grid>
                <Grid item xs={10}>
                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>{defaultValues.lTask.step1.worksiteName}</Typography>
                </Grid>

                {/*row*/}
                <Grid item xs={2}>
                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Data Reinnoire Adeverinta</Typography>
                </Grid>
                <Grid item xs={10}>
                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>
                        {Formatter.formatDatetoRO(defaultValues.lTask.step1.newCertificateDate)}
                    </Typography>
                </Grid>

                {/*row*/}
                <Grid item xs={2}>
                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Nota Curs</Typography>
                </Grid>
                <Grid item xs={10}>
                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>
                        {defaultValues.lTask.step3.comments}
                    </Typography>
                </Grid>

                {/*row*/}
                <Grid item xs={12}>
                    <Box sx={{ height: 650, width: '100%', marginTop: 2, marginBottom: 2 }}>
                        <DataGrid
                            rows={defaultValues.lTask.step3.examParticipants}
                            columns={examColumns}
                            pageSize={10}
                            rowsPerPageOptions={[10]}
                            checkboxSelection={false}
                            disableSelectionOnClick
                            experimentalFeatures={{ newEditingApi: true }}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Box>


        </React.Fragment>
    );
}